import React, { useEffect, useState } from 'react'
import 'react-toastify/dist/ReactToastify.css';
import CloseAccount from '../ProfileModals/closeaccount';
import ProfileSide from './profileSide';
import ProfileHome from './ProfileHome';
import UserOrders from './UserOrders';
import UserChild from './UserChild';
import UserProfile from './UserProfile';
import { useLocation } from 'react-router-dom';
import UserTransaction from './UserTransaction';
import { getWalletAmount } from '../../app/wallet/wallet.slice';
import { useDispatch, useSelector } from 'react-redux';
import ChangePassword from '../ProfileModals/changePassword';
import Loader from '../Common/Loader';
import NoticeModal from '../Common/Modal/NoticeModal';
import commonFunction from '../../Utils/commonFunction';

function MyProfile() {

    const [loader, setLoader] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const dispatch = useDispatch();
    const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
    const [resetProfile, setResetProfile] = useState(false);
    const closeaccountModal = () => setIsAccountModalOpen(false);
    const user = useSelector((state) => state.user);

    // State for password change
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
    const closePasswordModal = () => setIsPasswordModalOpen(false);

    const openAccountModal = () => {
        setIsAccountModalOpen(true);
    }

    const openPasswordModal = () => {
        setIsPasswordModalOpen(true);
    }

    const location = useLocation();
    const { isOrder, addChild, showTransaction } = location.state ? location.state : false;
    useEffect(() => {
        dispatch(getWalletAmount());
        // Check if the user's pop field is null or 0
        if (user && user?.user?.data) {
            const popUpValue = user?.user?.data?.popup;
            if (popUpValue === null || popUpValue === 0) {
                setShowModal(true); // Show the modal
            } else {
                setShowModal(false); // Show the modal
            }
        }
        setTimeout(() => {
            setLoader(false);
        }, 1000);
    }, [loader])

    if (loader) {
        return <Loader />;
    }

    const handleProfileTabClick = () => {
        setResetProfile(true);
        setTimeout(() => setResetProfile(false), 0);
    };

    const handleClose = async () => {
        setShowModal(false);
        let data = {
            popup: 1
        }
        await commonFunction.updateUserProfile(data);
    };

    const noticeHeading = "OBS ! Vigtig Orientering om Kommende Prisændringer";

    return (
        <>
            <main>
                {/* <NoticeModal
                    show={showModal}
                    onClose={handleClose}
                    heading={noticeHeading}
                /> */}
                <section className="tab_items wow pulse">
                    <div className="container">
                        <div className="row">
                            <ProfileSide openAccountModal={openAccountModal}
                                openPasswordModal={openPasswordModal}
                                isOrder={isOrder}
                                addChild={addChild}
                                showTransaction={showTransaction}
                                onProfileTabClick={handleProfileTabClick}
                            />
                            <div className="col-md-9 ">
                                <div className="tab_menuContents ">
                                    <div className="tab-content" id="myTabContent">
                                        <ProfileHome
                                            isOrder={isOrder}
                                            addChild={addChild}
                                            showTransaction={showTransaction}
                                        />
                                        {/* update profile div */}
                                        <UserProfile resetProfile={resetProfile} />
                                        {/* child Div */}
                                        <UserChild
                                            addChild={addChild}
                                        />
                                        {/* order div */}
                                        <UserOrders
                                            isOrder={isOrder}
                                        />
                                        {/* Close account section */}
                                        <CloseAccount
                                            isAccountOpen={isAccountModalOpen}
                                            closeAccModal={closeaccountModal}
                                        />
                                        <UserTransaction
                                            showTransaction={showTransaction}
                                        />
                                        <ChangePassword
                                            isPasswordModalOpen={isPasswordModalOpen}
                                            closePasswordModal={closePasswordModal}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
}

export default MyProfile
